import { console } from 'react-redux-app/lib/modules/core/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { getHowToStartUrl } from '../../utils/siteUrls';

import { getHasCampaigns, getIsActive } from '../../../auth/selectors';

import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';


export default ({ getState, dispatch }) => (
  function checkCampaignsHandler(nextState, successCallback, errorCallback) {
    try {
      const { pathname } = nextState.location;
      const howToStartUrl = getHowToStartUrl(getCurrentLang(getState()));

      if (getIsActive(getState()) && !getHasCampaigns(getState()) && howToStartUrl !== pathname) {
        errorCallback(howToStartUrl);
        return;
      }

      successCallback();
    } catch (e) {
      console.consoleError('checkCampaignsHandler failed', e);
      errorCallback(INTERNAL_ERROR_URI);
    }
  }
);
